import styled from 'styled-components';

// Import shared components from SupplierProductsDatagrid
export {
  DataGridContainer,
  GridContainer,
  QuantityInputInline,
  QuantityDisplay,
  HorizontalButtonContainer,
  DecrementButton,
  IncrementButton,
  getDatagridStyle,
} from '../SupplierProductsDatagrid/styledComponents';

// Recipe-specific styled components
export const NameContainer = styled.div`
  display: flex;
  height: 100%;
  flex-direction: column;
  justify-content: center;
  gap: 4px;
`;

export const QuantityContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 6px;
  padding: 8px 8px 8px 0px;
  border-radius: 6px;
  cursor: pointer;
  min-height: 56px;
  min-width: 180px;
  width: 180px;
  background-color: ${({ theme, isSelected }) =>
    isSelected ? theme.colors.brand.lightest : 'transparent'};
`;

export const QuantityIndicator = styled.div`
  width: 4px;
  height: 40px;
  border-radius: 2px;
  background-color: ${({ theme }) => theme.colors.brand.primary};
  flex-shrink: 0;
`;

export const UnitNameWrapper = styled.div`
  flex: 1;
  min-width: 0;
  max-width: 120px;
  display: flex;
  align-items: center;
`;
